module.exports = {

  title: '',

  /**
   * @type {boolean} true | false
   * @description 固定住 header，不跟随页面滚动
   */
  fixedHeader: true,

  /**
   * @type {boolean} true | false
   * @description 侧边连上头的logosidebar
  */
  sidebarLogo: true,
  /**
   * @type {boolean} true | false
   * @description tagsView显隐控制
   */
  tagsView: false,
  /**
   * @type {boolean} true | false
   * @description 底部footer显隐控制，
   * /src/layout/components/AppMain中.app-main-footer可以控制始终固定过随页面
   */
  footer: true,
  /**
   * @type {String} 
   * @description 请求数据地址
   */
  baseUrl:'/api',
  /**
   * @type {String} 
   * @description ws地址（soket地址）
   */
  baseWS:'ws://192.168.0.16:8001/connection/websocket',
}



// WEBPACK FOOTER //
// ./src/settings.js